import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent } from '../ui/dialog';

const LOGO_URL = '/logo.png';

export function OfferCheckoutConfirmDialog({
  open, onOpenChange, selectedOfferForCheckout,
  handleCheckoutOffer, processingOfferId,
}) {
  const offer = selectedOfferForCheckout;
  const itemCount = offer?.items?.length || 0;
  const savings = ((offer?.original_total || 0) - (offer?.final_price || 0));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0a0a0a] border-lime/30 max-w-md">
        <div className="text-center py-4">
          <div className="flex justify-center mb-6">
            <img src={LOGO_URL} alt="Tune4Tune" className="h-16 object-contain" />
          </div>

          <div className="bg-[#111] rounded-xl p-6 mb-6 border border-[#222]">
            <h3 className="font-heading text-lg font-bold mb-4 text-lime">Bulk Order Summary</h3>
            <div className="space-y-3 text-left">
              <div className="flex justify-between text-sm">
                <span className="text-[#888]">Artist</span>
                <span className="font-medium">{offer?.artist_name}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-[#888]">Items</span>
                <span className="font-mono">{itemCount} dubplate{itemCount !== 1 ? 's' : ''}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-[#888]">Original Price</span>
                <span className="font-mono line-through text-[#666]">${offer?.original_total?.toFixed(2)}</span>
              </div>
              <div className="border-t border-[#333] pt-3 mt-3">
                <div className="flex justify-between items-center">
                  <span className="font-medium">Negotiated Total</span>
                  <span className="font-mono text-2xl text-lime font-bold">${offer?.final_price?.toFixed(2)}</span>
                </div>
                <p className="text-xs text-lime mt-1 text-right">
                  You save ${savings.toFixed(2)}!
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mb-6 text-sm text-[#666]">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <span>Secure payment via Stripe</span>
          </div>

          <p className="text-xs text-[#666] mb-6">
            Your dubplates will be delivered within the artist&apos;s specified timeframe.
            Funds are held securely until you confirm delivery.
          </p>

          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1 border-[#333] hover:bg-[#1a1a1a]"
              disabled={processingOfferId === offer?.id}
            >
              Cancel
            </Button>
            <Button
              onClick={handleCheckoutOffer}
              disabled={processingOfferId === offer?.id}
              className="flex-1 bg-lime text-black hover:bg-lime/90 font-bold"
              data-testid="confirm-offer-checkout-btn"
            >
              {processingOfferId === offer?.id ? (
                <><Loader2 className="w-4 h-4 animate-spin mr-2" /> Processing...</>
              ) : (
                <>Pay ${offer?.final_price?.toFixed(2)}</>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
